import SettlementDetailInquiry from './settlement-detail-inquiry.vue'
export default SettlementDetailInquiry
